import { Vue } from './config'

if (document.getElementById('mortgage')) {
    new Vue({
        el: '#mortgage',
        components: {
        },
        data: {
            propertyPrice: 300000,
            deposit: 10000,
            interestRate: 5,
            loanTerm: 30,
        },
        computed: {
            loanAmount() {
                return this.propertyPrice - this.deposit
            },
            depositPercent() {
                return this.deposit / this.propertyPrice * 100
            },
            monthlyPayment() {
                let monthlyRate = this.interestRate / 12 / 100
                let totalMonths = this.loanTerm * 12

                if (monthlyRate === 0) {
                    return -(this.loanAmount / totalMonths)
                }

                let pmt = (monthlyRate * this.loanAmount) / (1 - Math.pow(1 + monthlyRate, -totalMonths))
                return pmt
            }
        },
        methods: {
            formatNum(val, dp = 2) {
                return val.toLocaleString('en-GB', { minimumFractionDigits: dp, maximumFractionDigits: dp })
            },
            getMask(value, ccy) {
                return ccy ? '£' + this.formatNum(value, 0) : this.formatNum(value, 2) + '%'
            }
        }
    })
}